import { defineStore } from 'pinia'
import { IncomingChatPromptEvent } from '@letsdial/socket'
import { ChannelSession } from '@letsdial/api/src/lib/types/ChannelSession'
import useLetsDialAPI from '../services/letsDialAPI/useLetsDialAPI'
import { useTaskStore } from './taskStore'

export const useChatStore = defineStore({
  // unique id of the store across your application
  id: 'chat',
  state: () =>
    ({
      activeChat: undefined,
      incomingChat: undefined,
      currentPlatform: undefined,
      selectedSessionId: undefined,
      fromMailbox: false
    }) as {
      incomingChat?: IncomingChatPromptEvent
      activeChat?: ChannelSession
      currentPlatform?: string
      selectedSessionId?: number
      fromMailbox: boolean
    },
  getters: {},
  actions: {
    async setIncomingChat(chat?: IncomingChatPromptEvent) {
      this.incomingChat = chat
      const taskStore = useTaskStore()
      if (!taskStore.expanded) {
        taskStore.toggleExpanded()
      }
    },
    async clearChat() {
      this.activeChat = undefined
      this.currentPlatform = undefined
    },
    async setPlatform(platform: string) {
      this.currentPlatform = platform
    },
    async getChat(sessionId) {
      const api = useLetsDialAPI()
      const result = await api.channelSessions.get(sessionId)
      this.activeChat = result.data ?? undefined
    },
    async setChannelSessionIdFromMailbox(sessionId: number) {
      this.selectedSessionId = sessionId
    },
    async setFromMailbox(value: boolean) {
      this.fromMailbox = value
    }
  },
})
